var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditW16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8067 3.75334C14.0667 4.01334 14.0667 4.43334 13.8067 4.69334L12.5867 5.91334L10.0867 3.41334L11.3067 2.19334C11.5667 1.93334 11.9867 1.93334 12.2467 2.19334L13.8067 3.75334ZM2 14V11.5L9.37333 4.12667L11.8733 6.62667L4.5 14H2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditW16);
export default __webpack_public_path__ + "static/media/edit_w16.3e03b56a4ddfa8843a2cc3596f5bf657.svg";
export { ForwardRef as ReactComponent };